import React from "react";
import { withRouter } from "react-router-dom";
import { TableOp } from "../../../components/table/TableOps.tsx";
import TableComponent from "../../../components/table/TableOps";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Input } from "@material-ui/core";
import ACCESS from "../../../ACCESS.js";
import Detalle from "./Detalle";

class DetallePagoTransportista extends TableComponent {
    componentDidMount() {
        this.tableConfig(
            {
                dataUrl: `pago-transportista-detalle/list`,
            },
            TableOp.Table(
                false,
                [
                    { label: "Folio Guía", id: "g_folio", render: (val, row) => row.g_folio || '' },
                    { label: "Transportista", id: "transportista_nombre", render: (val, row) => row.transportista_nombre || '' },
                    { label: "Chofer", id: "chofer", render: (val, row) => row.chofer || '' },
                    { label: "Tipo Pago", id: "tipo_pago" },
                    { label: "Pago", id: "valor_pagado", render: (val) => `$${Number(val).toFixed(2)}` },
                    { label: "KM", id: "km" },
                    { label: "Fecha Calculado", id: "createdAt" },
                ],
                [
                    { id: "ver", icon: "visibility", cb: this.onVerDetalle, access: [ACCESS.COBRANZA_PAGO_TRANSPORTISTA.VER_DETALLE_PAGO_TRANSPORTISTA] },
                ]
            )
        );
        this.table();
    }

    onFiltroChange = (name, val) => {
        this.setState({ [name]: val });
    }

    onSearch = () => {
        const { folio = "", transportista = "", chofer = "" } = this.state || {};
        let query = `pago-transportista-detalle/list?`;
        if (folio) query += `guia=${folio}&`;
        if (transportista) query += `transportista=${transportista}&`;
        if (chofer) query += `chofer=${chofer}&`;

        this.tableConfig(
            {
                dataUrl: query,
            },
            this.state.tableData
        )
        this.table()
    }

    onVerDetalle = (id, row) => {
        this.setState({ detalleDialog: { visible: true, row } });
    }

    onDetalleClose = () => {
        this.setState({ detalleDialog: { visible: false } });
    }

    onUpdateSuccess = () => {
        this.setState({ detalleDialog: { visible: false } });
        this.table();
    }

    render() {
        const { folio = "", transportista = "", chofer = "", detalleDialog = { visible: false } } = this.state || {};
        return (
            <div className="row">
                <div className="col-sm-12" style={{ textAlign: 'right', marginBottom: 15 }}>
                    <Input placeholder="Folio" value={folio} onChange={(e) => this.onFiltroChange('folio', e.target.value)} style={{ marginRight: 10 }} />
                    <Input placeholder="Transportista" value={transportista} onChange={(e) => this.onFiltroChange('transportista', e.target.value)} style={{ marginRight: 10 }} />
                    <Input placeholder="Chofer" value={chofer} onChange={(e) => this.onFiltroChange('chofer', e.target.value)} style={{ marginRight: 10 }} />
                    <Button onClick={this.onSearch} variant="contained" color="primary">
                        Buscar
                    </Button>
                </div>
                <div className="col-sm-12">
                    <this.TableRender />
                </div>

                <Dialog
                    onClose={this.onDetalleClose}
                    open={detalleDialog.visible}
                    fullWidth={true}
                    maxWidth={"md"}
                >
                    <DialogTitle onClose={this.onDetalleClose}>Detalle de Pago a Transportista</DialogTitle>
                    <DialogContent dividers>
                        <Detalle pagoData={detalleDialog.row} onUpdateSuccess={this.onUpdateSuccess} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.onDetalleClose}>Cerrar</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default withRouter(DetallePagoTransportista);
